import { useState, ReactNode } from 'react';
import LendoIcon from './LendoIcon';

interface LendoCollapsibleListProps {
  title: string;
  children: ReactNode;
}

export default function LendoCollapsibleList({ title, children }: LendoCollapsibleListProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="lendo-collapsible-list">
      <button onClick={() => setIsOpen(!isOpen)} className="collapsible-header">
        <h2 className="section-title">{title}</h2>
        <LendoIcon name="icon/angle-down" size="12px" className={`chevron ${isOpen ? 'open' : ''}`} />
      </button>
      {isOpen && <div className="collapsible-content">{children}</div>}
    </div>
  );
}
